import { FC } from 'react';
import { useRouter } from 'next/router';
import styled from './index.module.scss';
import { useReferralStore } from '@/components/Ambassador/ReferralProvider';
import { useLang } from '@/app/utils/useLang';

const Terms: FC = ({}) => {
    const { referralInfo } = useReferralStore();
    const { query } = useRouter();
    const { t } = useLang('referral');

    return (
        <div className={`${styled.terms}`}>
            <div className="content">
                <h5 className="title">{t('terms.title')}</h5>
                {query.inviteCode ? (
                    <div className="desc" dangerouslySetInnerHTML={{ __html: referralInfo?.receiveTc || '' }}></div>
                ) : (
                    <div className="desc" dangerouslySetInnerHTML={{ __html: referralInfo?.shareTc || '' }}></div>
                )}
            </div>
        </div>
    );
};

export default Terms;
